import React, { useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import EditStoreSettingsButton from './edit-store-settings-button';
import { StoreStatusCell } from './store-status-cell';
import style from './style.module.less';
import DataDrivenLogo from '../../../../components/data-driven-logo';
import getIsActive from '../../../../components/data-driven-logo/get-is-active';
import UserDateFormat from '../../../../components/user-date-format/index';
import { pages } from '../../nav-items';
import { settingsTabs } from '../constants';

const StoreRow = ({ store, openMarketplaceConnectionModal, openDeactivateMarketplaceModal, openErrorLog, isMarketPlaceGated = false }) => {
  const onOpenMarketplaceConnectionModalClick = useCallback(() => {
    openMarketplaceConnectionModal(store);
  }, [store, openMarketplaceConnectionModal]);

  const { isActive, refreshedDate, name, storeGuid, marketplaceId, storeId } = store;
  const isDeprecated = !getIsActive({ marketplaceId });

  const onOpenDeactivateMarketplaceModal = useCallback(() => {
    openDeactivateMarketplaceModal(name, storeId);
  }, [name, openDeactivateMarketplaceModal, storeId]);

  const detailUrl = `/${pages.settings.location}/${pages.stores.location}/${storeGuid}/${settingsTabs.storeSettings}`;
  const isInactive = !isActive || isDeprecated;

  return (
    <tr>
      <td
        className={classnames(style['left-store-cell'], {
          [style['is-inactive']]: isInactive,
          [style.disabled]: isMarketPlaceGated,
        })}
      >
        <DataDrivenLogo logoType='icon' marketplaceId={store.marketplaceId} />
        <span>{name}</span>
      </td>
      <td
        className={classnames(style['store-cell'], {
          [style['is-inactive']]: isInactive,
          [style.disabled]: isMarketPlaceGated,
        })}
      >
        {!!refreshedDate && <UserDateFormat value={refreshedDate} />}
      </td>
      <td
        className={classnames(style['store-cell'], {
          [style['is-inactive']]: isInactive,
          [style.disabled]: isMarketPlaceGated,
        })}
      >
        <StoreStatusCell isDeprecated={isDeprecated} isMarketPlaceGated={isMarketPlaceGated} openErrorLog={openErrorLog} store={store} />
      </td>
      <td
        className={classnames(style['right-store-cell'], {
          [style['is-inactive']]: isInactive,
          [style.disabled]: isMarketPlaceGated,
        })}
      >
        <EditStoreSettingsButton
          detailUrl={detailUrl}
          isDeprecated={isDeprecated}
          isMarketplaceMenuDisabled={isMarketPlaceGated}
          onOpenDeactivateMarketplaceModal={onOpenDeactivateMarketplaceModal}
          onOpenMarketplaceConnectionModalClick={onOpenMarketplaceConnectionModalClick}
          store={store}
        />
      </td>
    </tr>
  );
};

StoreRow.propTypes = {
  store: PropTypes.object.isRequired,
  openMarketplaceConnectionModal: PropTypes.func.isRequired,
  openDeactivateMarketplaceModal: PropTypes.func.isRequired,
};

export default StoreRow;
